import axios from '../../../utils/axiosInceptor'
import { getOrgnicationList,getOnlinePaymentsList,getCourierPaymentsList,getAllMerchants, exportAuditReport, exportLoginReport } from '../../../configs/constants'

export const getOrginationListService = async ()=>{
    try {
        const {data} = await axios.get(`${getOrgnicationList}`);
       
       return data?.result;
      
      } catch (e) {
        console.log({ e });
      }
  
}

  
export const getAllMerchantsService = async ()=>{
  try {
      const {data} = await axios.get(`${getAllMerchants}`);
     
     return data?.result;
    
    } catch (e) {
      console.log({ e });
    }

}
//  get online Reports data  Courier


export const getOnlineReportListService = async (payload)=>{


  try {
    const {data} = await axios.post(`${getOnlinePaymentsList}`,payload);
  
   return data;
  
  } catch (e) {
    console.log({ e });
  }
}

export const exportAuditReportService = async (payload, isLoginReport)=>{


  try {
    const {data} = await axios.post(`${isLoginReport ? exportLoginReport : exportAuditReport}`,payload);
  
   return data;
  
  } catch (e) {
    console.log({ e });
  }
}
//  get online Reports data  Courier

export const getCourierReportListService = async (payload)=>{


   try {
     const {data} = await axios.post(`${getCourierPaymentsList}`,payload);
   
    return data;
   
   } catch (e) {
     console.log({ e });
   }
 }
 